// Как запустить сайт в браузере: поверх готовой страницы (гидратация) или с нуля (изменение seo).
import { hydrate, type DehydratedState, type QueryClient } from "@tanstack/react-query";
import { HYDRATION_MISMATCH_PREFIX, PRERENDER_DATA_ID } from "./shared";

export type StartMode = "hydrate" | "render";

// Гидратировать можно только свою готовую страницу и только на сайте. В Mini App корень
// рисуется иначе (развилка вместо витрины), а оболочка app.html готовой разметки не содержит.
// /index.html, открытый напрямую, или старая вкладка с другим путём — тоже рисуются с нуля.
export function chooseStartMode(rootElement: HTMLElement, pathname: string, isMiniApp: boolean): StartMode {
  if (isMiniApp) return "render";
  const prerenderedPath = rootElement.dataset.path;
  if (prerenderedPath === undefined || rootElement.childElementCount === 0) return "render";
  return prerenderedPath === pathname ? "hydrate" : "render";
}

// Кладёт в кэш запросов данные, с которыми нарисована готовая страница: первая отрисовка
// в браузере совпадает с разметкой, а запросы к серверу обновят их после.
export function seedPrerenderedQueries(queryClient: QueryClient, ownerDocument: Document): boolean {
  const dataElement = ownerDocument.getElementById(PRERENDER_DATA_ID);
  if (dataElement === null || dataElement.textContent === null) return false;
  try {
    hydrate(queryClient, JSON.parse(dataElement.textContent) as DehydratedState);
    return true;
  } catch {
    return false;
  }
}

export function reportHydrationMismatch(error: unknown): void {
  const reason = error instanceof Error ? error.message : String(error);
  console.error(`${HYDRATION_MISMATCH_PREFIX}: ${reason}`);
}
